import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { DiscoveryStatusEnum, DiscoveryTypeEnum } from 'src/app/moov-common/services/personal-user-data/personal-user-data';

@Component({
  selector: 'app-discovery-process-container',
  templateUrl: './discovery-process-container.component.html',
  styleUrls: ['./discovery-process-container.component.scss']
})
export class DiscoveryProcessContainerComponent extends BaseComponent implements OnInit {

  eDiscoveryTypeEnum = DiscoveryTypeEnum;
  eDiscoveryStatusEnum = DiscoveryStatusEnum;

  constructor() { 
    super();
  }

  ngOnInit(): void {
  }

}
